import { ThemeEvents, VariantUpdateEvent } from '@theme/events';

class CertificationPopupRoot extends HTMLElement {
  /** @type {Record<string, boolean> | null} */
  #variantMap = null;

  connectedCallback() {
    this.#variantMap = this.#parseVariantMap();

    const closestSection = this.closest('.shopify-section, dialog');
    closestSection?.addEventListener(ThemeEvents.variantUpdate, this.#onVariantUpdate);
  }

  disconnectedCallback() {
    const closestSection = this.closest('.shopify-section, dialog');
    closestSection?.removeEventListener(ThemeEvents.variantUpdate, this.#onVariantUpdate);
  }

  /**
   * @returns {Record<string, boolean> | null}
   */
  #parseVariantMap() {
    const mapScript = this.querySelector('[data-certification-variant-map]');

    if (!mapScript?.textContent) {
      return null;
    }

    try {
      return JSON.parse(mapScript.textContent);
    } catch {
      return null;
    }
  }

  /**
   * @param {VariantUpdateEvent} event
   */
  #onVariantUpdate = (event) => {
    if (this.dataset.designMode === 'true') {
      return;
    }

    if (event.detail.data.newProduct) {
      this.dataset.productId = event.detail.data.newProduct.id;
      this.#refreshVariantMapFromHtml(event.detail.data.html);
    } else if (event.target instanceof HTMLElement && event.target.dataset.productId !== this.dataset.productId) {
      return;
    }

    const variantId = event.detail.resource?.id;

    if (!variantId || !this.#variantMap) {
      return;
    }

    this.#setVisible(Boolean(this.#variantMap[String(variantId)]));
  };

  /**
   * @param {Document} html
   */
  #refreshVariantMapFromHtml(html) {
    const newRoot = html.querySelector(
      `certification-popup-root[data-certification-popup="${this.dataset.certificationPopup}"]`
    );
    const newMapScript = newRoot?.querySelector('[data-certification-variant-map]');

    if (!newMapScript?.textContent) {
      return;
    }

    try {
      this.#variantMap = JSON.parse(newMapScript.textContent);
    } catch {
      // Keep the existing map if parsing fails.
    }
  }

  /**
   * @param {boolean} show
   */
  #setVisible(show) {
    if (show) {
      this.removeAttribute('hidden');
      return;
    }

    this.setAttribute('hidden', '');

    const dialogComponent = this.querySelector('dialog-component');

    if (dialogComponent && 'closeDialog' in dialogComponent && typeof dialogComponent.closeDialog === 'function') {
      dialogComponent.closeDialog();
    }
  }
}

if (!customElements.get('certification-popup-root')) {
  customElements.define('certification-popup-root', CertificationPopupRoot);
}
